import type { FC } from "react";

import { SWReactIcons } from "@similarweb/icons";

import { IconWrapper, LabelContainer, LabelName, LabelValue, LegendItemContainer } from "./ChartLegend.styles";

interface IChartLegendItemProps {
    name: string;
    value: string;
    color: string;
    isFocused?: boolean;
}

export const ChartLegendItem: FC<IChartLegendItemProps> = (props) => {
    const { name, value, color, isFocused } = props;
    const legendIcon = name === "Desktop" ? "desktop" : "mobile-web";

    return (
        <LegendItemContainer isFocused={isFocused}>
            <LabelContainer>
                <IconWrapper>
                    <SWReactIcons
                        size="xs"
                        iconName={legendIcon}
                    />
                </IconWrapper>
                <LabelName isFocused={isFocused}>{name}</LabelName>
            </LabelContainer>
            <LabelValue
                isFocused={isFocused}
                color={color}
            >
                {value}
            </LabelValue>
        </LegendItemContainer>
    );
};
